import {
    Callout,
    IconInformationUserRegular,
    IconMobileDeviceRegular,
    IconTelephonePotRegular,
    IconWifiRegular,
    Text1,
    skinVars,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import './index.scss';
import ChatSupport from '../ChatSupport';
import { useTranslation } from 'react-i18next';
import ChatText from '../ChatText';
import { getListMotives, getListMotivesById } from '../../services/ProblemService';
import { AxiosError, AxiosResponse } from 'axios';
import {
    IProblemCategory,
    IProblemDiagnosis,
    EProblemFeedback,
    EProblemFeedbackType,
} from '../../models/Problems.interfaces';
import Lottie from 'lottie-react';
import typing from '../../assets/lotties/typing.json';
import navigateParams from '../../utils/navigation/navigateParams';
import { useNavigate } from 'react-router-dom';
import { literalsFeedback } from '../../pages/support/utils.chat';
import { IConsumption, IProduct } from '../../utils/store/model/store.model';

enum ETypeProduct {
    FIJO = 'FIJO',
    INTERNET = 'INTERNET',
    MOVIL = 'MÓVIL',
}
interface IChatTabsProducts {
    onEmitProduct: Function;
    products: { [key: string]: IProduct[] | IConsumption[] | null };
}

export interface IChatProduct {
    type: string;
    productPsId: string[];
    number: string[];
}

export const ChatTabsProducts: React.FC<IChatTabsProducts> = ({ products, onEmitProduct }: IChatTabsProducts) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(true);
    const [tab, setTab] = useState(true);
    const [tabSelected, setTabSelected] = useState<IProblemDiagnosis>();
    const [productType, setProductType] = useState<any>([]);

    useEffect(() => {
        if (Object.values(products)?.some((product: any) => product?.length > 0)) initIncident();
    }, [products]);

    const getInfoProduct = (product: { [key: string]: any }) => {
        const { productPsId, number } = product;
        return {
            productPsId,
            number,
        };
    };

    const handleMatchProduct = (product: { [key: string]: any }) => getInfoProduct(product);

    const getProducts = (data: IProblemCategory[], identifier?: 'FIJO' | 'MÓVIL' | 'INTERNET') => {
        const removeDuplicates = (products: any[]) =>
            Array.from(new Set(products.map((a: { [key: string]: any }) => a?.productPsId))).map((id: string) => {
                return products.find((a: { [key: string]: any }) => a?.productPsId === id);
            });
        const tabsProducts = (data as IProblemCategory[]).map((response: IProblemCategory) => {
            const { id, name, description, motive } = response;
            const handleMatch = () => {
                const isIdentifierProduct: boolean = ['FIJO', 'MÓVIL', 'INTERNET'].includes(identifier!);
                const identifierProduct: string | undefined = isIdentifierProduct ? identifier : name;
                let _products: any[] = [];
                if (
                    ETypeProduct.FIJO === identifierProduct!.toLocaleUpperCase() ||
                    ETypeProduct.INTERNET === identifierProduct!.toLocaleUpperCase()
                ) {
                    (products?.bundles as [])?.forEach((item: any) => {
                        const fibers = [handleMatchProduct(item?.fiber)];
                        _products.push(fibers);
                    });
                    (products?.fibers as [])?.forEach((item: any) => {
                        const fibers = [handleMatchProduct(item)];
                        _products.push(fibers);
                    });
                }

                if (ETypeProduct.MOVIL === identifierProduct!.toLocaleUpperCase()) {
                    (products?.bundles as [])?.forEach((item: any) => {
                        if (item.additionalMobiles?.length) {
                            const additional = item.additionalMobiles.map((item: any) => handleMatchProduct(item));
                            _products.push(...additional);
                        }
                        if (item?.mainMobile && Object.values(item?.mainMobile)?.length) {
                            const main = [handleMatchProduct(item?.mainMobile)];
                            _products.push(main);
                        }
                    });
                    (products?.mobiles as [])?.forEach((item: any) => {
                        const mobiles = [handleMatchProduct(item)];
                        _products.push(mobiles);
                    });
                }

                return _products.flat();
            };

            return {
                id,
                type: description,
                motive,
                products: removeDuplicates(handleMatch()),
            };
        });

        return tabsProducts;
    };

    const initIncident = () => {
        getListMotives()
            .then((response: AxiosResponse) => {
                const { data } = response;
                const tabsProducts = getProducts(data);
                setProductType(tabsProducts);
                setLoading(false);
            })
            .catch((error: AxiosError) => {
                console.error(error);
                setLoading(false);
                const queryParams = {
                    phase: EProblemFeedbackType.ERROR,
                    error: EProblemFeedback.SERVICE,
                    ...literalsFeedback(EProblemFeedback.DIAGNOSIS),
                };
                if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                    navigate(`/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`);
                }
            });
    };

    const setTabProduct = (type: ETypeProduct) => {
        if (type.toLocaleUpperCase() === ETypeProduct.FIJO) {
            return (
                <div className='chatTabsProducts__tabs-product'>
                    <IconTelephonePotRegular
                        className='chatTabsProducts__tabs-product-icon'
                        size={24}
                        color={skinVars.colors.controlActivated}
                    />
                    <Text1 regular color={skinVars.colors.textLink}>
                        {t('permanent')}
                    </Text1>
                </div>
            );
        }
        if (type.toLocaleUpperCase() === ETypeProduct.INTERNET) {
            return (
                <div className='chatTabsProducts__tabs-product'>
                    <IconWifiRegular
                        className='chatTabsProducts__tabs-product-icon'
                        size={24}
                        color={skinVars.colors.controlActivated}
                    />
                    <Text1 regular color={skinVars.colors.textLink}>
                        {t('fiber')}
                    </Text1>
                </div>
            );
        }
        if (type.toLocaleUpperCase() === ETypeProduct.MOVIL) {
            return (
                <div className='chatTabsProducts__tabs-product'>
                    <IconMobileDeviceRegular
                        className='chatTabsProducts__tabs-product-icon'
                        size={24}
                        color={skinVars.colors.controlActivated}
                    />
                    <Text1 regular color={skinVars.colors.textLink}>
                        {t('mobile')}
                    </Text1>
                </div>
            );
        }
    };

    const selectTabProduct = (product: IProblemDiagnosis) => {
        setTab(false);

        if (product?.motive) {
            setTabSelected(product);
            onEmitProduct({ product: product, step: 2 });
        } else {
            setLoading(true);
            getListMotivesById({ categoryId: product.id }).then((response: AxiosResponse) => {
                const { data } = response;
                const identifierProduct: { [key: string]: any } = {
                    FIJO: 'FIJO',
                    MÓVIL: 'MÓVIL',
                    INTERNET: 'INTERNET',
                };

                const _products = getProducts(data, identifierProduct[product.type.toLocaleUpperCase()]);
                setLoading(false);
                setTabSelected(product);
                onEmitProduct({ product: { ...product, products: _products[0].products }, step: 2 });
            });
        }
    };

    const selectedProductProblem = () => {
        if (tabSelected?.id === '495') {
            return <ChatText context={'response'} text={t('supportResponseChatTabsProductsFijo')}></ChatText>;
        } else if (tabSelected?.id === '486') {
            return <ChatText context={'response'} text={t('supportResponseChatTabsProductsFibra')}></ChatText>;
        } else if (tabSelected?.id === '489') {
            return <ChatText context={'response'} text={t('supportResponseChatTabsProductsMovil')}></ChatText>;
        }
    };

    return (
        <div className='chatTabsProducts'>
            <ChatSupport text={t('supportChatAnswerTabProduct')}></ChatSupport>
            {loading ? (
                <ChatSupport text={<Lottie animationData={typing} style={{ height: 18, width: 34 }} />}></ChatSupport>
            ) : (
                tab && (
                    <>
                        <div className='chatTabsProducts__tabs'>
                            {productType?.map((item: IProblemDiagnosis, index: any) => {
                                const { type } = item;
                                return (
                                    <div
                                        key={index}
                                        onClick={() => selectTabProduct(item)}
                                        className='chatTabsProducts__tabs-product'
                                        style={{
                                            borderStyle: 'solid',
                                            borderWidth: '1px',
                                            borderColor: skinVars.colors.borderSelected,
                                        }}
                                    >
                                        {setTabProduct(type as ETypeProduct)}
                                    </div>
                                );
                            })}
                        </div>
                        <div className='chatTabsProducts__callout'>
                            <Callout
                                icon={<IconInformationUserRegular color={skinVars.colors.textLink} />}
                                description={t('chatTabsProductCallout')}
                            />
                        </div>
                    </>
                )
            )}
            {selectedProductProblem()}
        </div>
    );
};

export default ChatTabsProducts;
